// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6f9222b7","703":"5111e544"}[chunkId] + ".chunk.js";
};